import { useMutation } from '@apollo/client/react';
import { Button, Modal } from 'antd';
import React from 'react';
import {
  CONFIRMATION_REGISTER_MODAL_TITLES,
  CONFIRMATION_TYPES,
  ROUTES,
  TAB_KEYS,
} from '../../../../../../common/constants';
import useRouter from '../../../../../../common/useRouter';
import {
  ARCHIVE_REGISTER,
  DRAFT_REGISTER,
  PUBLISH_REGISTER,
} from '../../../../graphql/Mutation';

const ConfirmationModal = ({
  type,
  showModal,
  setShowModal,
  handleRefetch,
  handleCustomAction,
}) => {
  const {
    navigate,
    params: { projectId, registerId },
  } = useRouter();

  const [archiveRegister] = useMutation(ARCHIVE_REGISTER, {
    fetchPolicy: 'network-only',
    onError() {},
    onCompleted() {
      handleRefetch();
    },
  });

  const [publishRegister] = useMutation(PUBLISH_REGISTER, {
    fetchPolicy: 'network-only',
    onError() {},
    onCompleted(res) {
      navigate(
        `${ROUTES.PROJECTS}/${projectId}/${TAB_KEYS.REGISTER}/${res?.publishRegister?.id}`,
      );
    },
  });

  const [draftRegister] = useMutation(DRAFT_REGISTER, {
    fetchPolicy: 'network-only',
    onError() {},
    onCompleted(data) {
      const id = data?.draftRegister?.id;
      navigate(
        `${ROUTES.PROJECTS}/${projectId}/${TAB_KEYS.REGISTER}/${id}/edit-control`,
      );
    },
  });
  const handleCancel = () => {
    setShowModal(false);
  };

  const handleSave = async () => {
    if (type === CONFIRMATION_TYPES.DISCARD && handleCustomAction) {
      handleCustomAction();
      return;
    }

    try {
      switch (type) {
        case CONFIRMATION_TYPES.ARCHIVE:
          await archiveRegister({
            variables: {
              archiveRegisterId: registerId,
            },
          });
          setShowModal(false);
          break;

        case CONFIRMATION_TYPES.UNARCHIVE:
        case CONFIRMATION_TYPES.EDIT:
          await draftRegister({
            variables: {
              draftRegisterId: registerId,
            },
          });
          setShowModal(false);
          break;

        case CONFIRMATION_TYPES.SAVE:
          await publishRegister({
            variables: {
              publishRegisterId: registerId,
            },
          });
          setShowModal(false);
          break;

        default:
          setShowModal(false);
          break;
      }
    } catch {
      // handled silent error
    }
  };

  return (
    <Modal
      maskClosable={false}
      centered
      open={showModal}
      onCancel={handleCancel}
      closable={false}
      footer={null}
    >
      <h2>CAUTION</h2>
      <p>{CONFIRMATION_REGISTER_MODAL_TITLES?.[type]?.TITLE}</p>
      <div className="form-buttons">
        <Button
          shape="round"
          className="cancel-button"
          onClick={handleCancel}
          id="register-confirmation-cancel-btn"
        >
          Cancel
        </Button>
        <Button
          shape="round"
          type="primary"
          className="save-button"
          onClick={handleSave}
          id="register-confirmation-confirm-btn"
        >
          {CONFIRMATION_REGISTER_MODAL_TITLES?.[type]?.BUTTON_TITLE}
        </Button>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
